//
//
//
//
//
//
//

import _ from 'underscore'
// import DIC from '@/index/dictionary'

export default {
  props: {
    visible: {
      default: false
    },
    initialForm: {
      default: () => ({})
    }
  },
  data: function () {
    return {
      currentVisible: this.visible,
      loading: false,
      search: {
        bid: undefined,
        cid: undefined,
        q: undefined,
        status: 0,
        orderParams: 'updateTime'
      },
      table: [],
      page: {
        pageNo: 1,
        pageSize: 20,
        total: 0
      },
      brandOptions: [],
      categoryOptions: []
    }
  },
  watch: {
    visible: {
      handler (val) {
        this.currentVisible = val
      },
      immediate: true
    }
  },
  components: {
    PageHeader: () => import('./components/PageHeader/index.vue'),
    PageMain: () => import('./components/PageMain/index.vue')
  },
  methods: {
    handleLoadTableData () {
      this.loading = true
      let data = _.extend({}, this.search, _.pick(this.page, 'pageNo', 'pageSize'))
      // console.log('data', data)
      this.$axios.get('/mtea/store/admin/goods/list', {params: data}).then(res => {
        // console.log('res', res)
        this.page.total = res.total
        this.table = res.records

      }).finally(() => {
        this.loading = false
      })
    },
    handleSubmit (row) {
      // this.$emit('submit', row)
      // this.$emit('update:visible', false)
      this.handleLoadTableData()
    },
    handleClose () {
      _.extend(this, _.pick(this.$options.data(), 'search', 'table', 'page'))
      this.$emit('submit', {})
    },
    handleOpen () {
      let p1 = new Promise((resolve, reject) => {
        this.$axios.get('/mtea/store/admin/goods/category/list', { params: {} }).then(res => {
          this.categoryOptions = res
        }).finally(() => {
          resolve()
        })
      })
      let p2 = new Promise((resolve, reject) => {
        this.$axios.get('/mtea/store/admin/goods/brand/list', { params: {} }).then(res => {
          this.brandOptions = res
        }).finally(() => {
          resolve()
        })
      })
      Promise.all([p1, p2]).then(() => {
      })
      this.handleLoadTableData()
    }
  }
}
